/**
 * Stacking order for nested MUI dialogs.
 * AI Results / company-scope dialogs use ELEVATED; PDF opened from them uses PDF_ABOVE_ELEVATED.
 */
export const ELEVATED_DIALOG_Z_INDEX_OFFSET = 2500;

export const PDF_VIEWER_ABOVE_ELEVATED_DIALOG_Z_INDEX_OFFSET = 2600;

/** Tooltips inside elevated dialogs (above modal + {@link ELEVATED_DIALOG_Z_INDEX_OFFSET}). */
export const ELEVATED_DIALOG_TOOLTIP_Z_INDEX_OFFSET = 100;

/** Global snackbar/toast above elevated dialogs and nested modals. */
export const GLOBAL_SNACKBAR_ABOVE_ELEVATED_Z_INDEX_OFFSET = 200;
